export default __webpack_public_path__ + "static/media/reddevileddates.d43c3d7f.jpg";